import React from 'react'
import { LoadableSelect } from '../../../../../components/Inputs'
import Client from '../../../../../client'

import config from '../../../../../config'

interface Props {
  categoryMarketCategoryId: any
  specificName: any
  createable: boolean
  value: string
  required: boolean
  onChange: any
  allowDangerIntent?: boolean
  relevanceSearchCount?: number
}

export default class SpecificRenderer extends React.PureComponent<Props> {
  onChange = (v: { value: string; productRequired: boolean }) => {
    this.props.onChange(v && v.value, v && v.productRequired)
  }

  render() {
    const { categoryMarketCategoryId, required, specificName, value, createable } = this.props
    return (
      <LoadableSelect
        load={() => Client.categorySpecificRecommendations(categoryMarketCategoryId, specificName)}
        process={d => {
          const values = (d.valueRecommendations || []).map(vr => ({
            value: vr.value,
            label: vr.value,
            productRequired: vr.validationRules.productRequired === true
          }))

          // insert a created value, only if the input:
          // - is createable,
          // - has an actual value (not undefined),
          // - does not already exist in the list
          if (createable && value && !values.find(vr => vr.value === value)) {
            values.push({
              value,
              label: value,
              productRequired: false
            })
          }

          if (config.EBAY_AUTOFILL_SPECIFICS()) {
            if (value && !values.find(vr => vr.value === value)) {
              const correctlyCasedValue = values.find(vr => vr.value.toUpperCase() === value.toUpperCase())
              if (correctlyCasedValue) {
                // Their hammoq attributes had a valid value, but with the wrong case, like "floral" instead of "Floral". Fix it for them.
                this.onChange(correctlyCasedValue)
              } else {
                // This was provided with an invalid value (probably from a builder template), so remove it.
                // Because we have to make an API call per specific to get possible values to determine if autofilled specifics are valid,
                // this component is a convenient place to do this check.
                // We could get by without this. Amazingly, ebay's API will allow us to send up invalid values (and they display on the item page!)
                // even though free-text isn't allowed. But let's not depend on this.
                this.onChange(null)
              }
            }
          }

          return values
        }}
        simpleValue={false}
        onChange={this.onChange}
        title={specificName}
        virtualized
        autoload={value}
        optional={!required}
        required={required}
        value={value}
        createable={createable}
        placeholder={createable ? 'Create or Select' : 'Select'}
        // react-select-same-height-as-blueprint - because often times these specifics will be on the same line
        // as a blueprint InputGroup, like for "Condition Description" or ConditionDescriptorPicker
        className="react-select-same-height-as-blueprint"
      />
    )
  }
}
